/* Wades Books — header behaviour: inline search, support flyout, closing menus when you leave them */
(function () {
  'use strict';
  var html = document.documentElement;
  var desk = window.matchMedia('(min-width: 990px)');
  var hover = window.matchMedia('(hover: hover)').matches;
  /* Header is no longer sticky: clear anything an older version may have set */
  html.classList.remove('w-compact');
  html.style.removeProperty('--w-top');
  html.style.removeProperty('--w-ann-h');

  /* Support icon opens the help flyout (desktop hover) */
  var sup = document.querySelector('[data-w-support]');
  var ghost = document.querySelector('.a-nav__link--ghost');
  var logo = document.querySelector('.a-nav__logo');
  function closeFlyout() { logo && logo.dispatchEvent(new Event('mouseenter')); }
  if (sup && ghost && hover) {
    sup.addEventListener('mouseenter', function () { ghost.dispatchEvent(new Event('mouseenter')); });
    document.querySelectorAll('.a-nav__right .a-nav__icon:not([data-w-support])').forEach(function (el) {
      el.addEventListener('mouseenter', closeFlyout);
    });
  }
  /* Moving up out of the category row (into the logo / search row) closes the dropdown */
  if (hover) {
    document.querySelectorAll('.w-center, .a-nav__bar, .w-ann').forEach(function (el) { el.addEventListener('mouseenter', closeFlyout); });
    document.documentElement.addEventListener('mouseleave', closeFlyout);
  }

  /* Inline search bar with live suggestions */
  var input = document.querySelector('[data-w-search-input]');
  var box = document.querySelector('[data-w-search-results]');
  var timer = null, ctrl = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function closeResults() { if (box) { box.classList.remove('is-open'); } }
  function quick() {
    return '<p class="a-fly__label">Popular</p><ul class="a-search__quick" role="list">' +
      '<li><a href="/collections/new-in">→ New in</a></li>' +
      '<li><a href="/collections/trending-titles">→ Trending titles</a></li>' +
      '<li><a href="/collections/rare-and-collectable">→ Rare &amp; collectable</a></li>' +
      '<li><a href="/pages/request-service">→ Can\'t find it? Request a title</a></li></ul>';
  }
  if (input && box) {
    input.addEventListener('focus', function () {
      closeFlyout();
      if (!input.value.trim()) box.innerHTML = quick();
      box.classList.add('is-open');
    });
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { box.innerHTML = quick(); box.classList.add('is-open'); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data && data.resources && data.resources.results) || {};
            var prods = res.products || [], colls = res.collections || [];
            var out = '';
            if (colls.length) {
              out += '<p class="a-fly__label">Categories</p><ul class="a-search__colls" role="list">' +
                colls.slice(0, 5).map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') + '</ul>';
            }
            out += '<p class="a-fly__label">' + (prods.length ? 'Products' : 'No products found') + '</p>';
            out += prods.map(function (p) {
              var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
              return '<a class="a-search__hit" href="' + esc(p.url) + '">' + img + '<span><span class="a-search__hit-t">' + esc(p.title) +
                '</span><span class="a-search__hit-p">' + money(p.price) + '</span></span></a>';
            }).join('');
            out += '<a class="a-search__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '” ›</a>';
            box.innerHTML = out;
            box.classList.add('is-open');
          })
          .catch(function () {});
      }, 180);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-w-sbar]')) closeResults(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeResults(); input.blur(); } });
  }

  /* Cmd/Ctrl+K focuses the search bar */
  window.addEventListener('keydown', function (e) {
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey) && input) {
      e.preventDefault(); e.stopImmediatePropagation(); input.focus();
    }
  }, true);
})();
